module.exports = __webpack_public_path__ + "assets/static/media/logo-white-recruitfirst.825d8624.png";